export default __webpack_public_path__ + "static/media/water-pic-1.ac261b00.svg";